import Vue from 'vue'
import Vuex from 'vuex'
import menu from '../config/menu'
import studio from '../config/studio'
import firstEditor from '../config/firstEditor'
import secondaryEditor from '../config/secondaryEditor'
import traineeEditor from '../config/traineeEditor'
import museummenu from '../config/museummenu'
import provinceAdmin from '../config/provinceAdmin'

Vue.use(Vuex)
var userinfo = localStorage.getItem('userinfo') || '{}'
userinfo = JSON.parse(userinfo)
const store = new Vuex.Store({
    state: {
        menu: '',
        menuActiveName: '',
        menuOpenNames: [],
        breadcrumb: [],
        userinfo: userinfo,
        isActive: false,
        videourl: '',
        cover: '',
        sourceVideoUrl: '',
        saveId: '',
        material: {},
        emailAddress: '',
        tabname: 'wechat'
    },
    getters: {
        getMaterial: (state) => state.material,
    },
    mutations: {
        tabname(state, tabname) {
            state.tabname = tabname;
        },
        breadcrumb(state, path) {
            var result = []
            recursiveBreadcrumb('path', path, state.menu, 0, result)
            state.breadcrumb = result
        },
        menu(state, route) {
            if (state.userinfo.typeCode) {
                var typeCode = state.userinfo.typeCode.toLowerCase()
                console.log(typeCode)
                if (typeCode == 'studio') { //普通用户
                    state.menu = studio;
                } else if (typeCode == 'admin') { //管理员
                    if(state.userinfo.username=='museum'){
                        state.menu = museummenu;
                    } else {
                        state.menu = menu;
                    }
                } else if (typeCode == 'firsteditor') { //一审
                    state.menu = firstEditor;
                } else if (typeCode == 'secondaryeditor') { //二审
                    state.menu = secondaryEditor;
                } else if (typeCode == 'trainee') { //实习编辑
                    state.menu = traineeEditor;
                } else if (typeCode == 'provincial') { //省级管理员
                    console.log(provinceAdmin)
                    state.menu = provinceAdmin;
                }

                let activeName = ''
                let openNames = ["1", "2", "3", "4", "5", "6", "7"]
                state.menu.forEach((n, i) => {
                    if (n.path === route.path || (n.match && n.match.indexOf(route.name))) {
                        activeName = i + ''
                    } else if (n.children) {
                        n.children.forEach((m, j) => {
                            if (m.path === route.path || (m.match && m.match.indexOf(route.name) >= 0)) {
                                activeName = i + '-' + j
                                openNames.push(i + '')
                            }
                        })
                    }
                })
                state.menuActiveName = activeName
                state.menuOpenNames = [...openNames]
            }
        },
        set(state, data) {
            Object.assign(state, data)
        },
        setMaterial(state, material) {
            state.material = material;
        }
    },
    actions: {
        setMaterial({ commit }, argu) {
            commit('setMaterial', argu)
        }
    },
    articleBack: true
})

function recursiveBreadcrumb(key, val, data, index, result) {
    for (var i = 0, l = data.length; i < l; i++) {
        var e = data[i]
        if (e[key] && val === e[key]) {
            result[index] = e
            return true
        } else if (e.children) {
            var re = recursiveBreadcrumb(key, val, e.children, index + 1, result)
            if (re) {
                result[index] = e
                return true
            }
        }
    }
    return false
}

export default store


// WEBPACK FOOTER //
// ./src/store/index.js